// Shared pieces for the sign-in, invite, reset and message pages.
// Paper page, Manuscript logo above one white card.
export function Shell({ children, width = 440 }) {
  return (
    <div className="auth-page">
      <img className="auth-logo" src="/brand/manuscript-light.svg" alt="GhostWriter Events" width="260" height="95" />
      <main className="auth-card" style={{ maxWidth: width }}>
        {children}
      </main>
      <div className="auth-foot">
        <a href="https://ghostwriter-events.com">ghostwriter-events.com</a>
        <span aria-hidden="true" className="text-muted">·</span>
        <a href="/privacy">Privacy</a>
      </div>
    </div>
  );
}

// The Courier label at the top of a card ("PLANNER DASHBOARD").
export function Brand({ sub }) {
  if (!sub) return null;
  return <div className="label">{sub}</div>;
}

export function Message({ title, body, children }) {
  return (
    <Shell>
      <h1 className="display" style={{ fontSize: 34, margin: 0 }}>{title}</h1>
      <div style={{ fontSize: 17, lineHeight: 1.6 }}>{body}</div>
      {children}
    </Shell>
  );
}

export function Loading({ label }) {
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--paper)" }}>
      <div className="label">{label || "Loading…"}</div>
    </div>
  );
}

export function ErrorText({ children }) {
  if (!children) return null;
  return <div role="alert" className="error-text">{children}</div>;
}

export function Label({ text, children }) {
  return (
    <label style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <span className="field-label">{text}</span>
      {children}
    </label>
  );
}
